import { get, mapValues } from 'lodash';

import { LOOK_SUCCESS } from '../actions/embed-actions';

const initialState = { looks: {} };

export default function embeds(state = initialState, action = {}) {
  switch (action.type) {
    case LOOK_SUCCESS:
      return {
        ...state,
        looks: {
          ...state.looks,
          [`look-${action.id}`]: {
            url: action.url,
            blocked: action.blocked,
            blockedMessage: action.blocked
              ? 'Contact your Client Success Representative to learn more about this data'
              : ''
          }
        }
      };

    default:
      return state;
  }
}

export const getLook = (lookId, state) =>
  get(state.embeds, `looks.look-${lookId}`, { url: '', blocked: false });

export const getLooks = (looksConfig, state) =>
  mapValues(looksConfig, (_, name) => getLook(name, state));
